const LOGIN_POLICY_KEY = 'loginPolicy'
const EMAIL_HINT_KEY = 'emailHint'
const POST_LOGIN_DESTINATION_KEY = 'postLoginDestination'

export const DEFAULT_B2C_LOGIN_POLICY = 'B2C_1A_SIGNUP_SIGNIN'

export const PUBLIC_BOOKING_PATH_PREFIXES = [
  '/booking/create',
  '/booking/status',
  '/booking/flexible',
  '/offline-booking',
]

export const isPublicBookingPath = (path?: string | null) =>
  !!path &&
  PUBLIC_BOOKING_PATH_PREFIXES.some((prefix) => path.startsWith(prefix))

let inMemoryPostLoginDestination: string | null = null

const getEnvironmentDetails = () => process.env.REACT_APP_B2C_ENVIRONMENTDETAILS

const getSessionStorage = () => {
  if (typeof window === 'undefined') return null
  try {
    const storage = window.sessionStorage
    storage.getItem(POST_LOGIN_DESTINATION_KEY)
    return storage
  } catch {
    return null
  }
}

const normalizeInternalDestination = (raw?: string | null) => {
  const trimmed = (raw || '').trim()
  if (!trimmed) return undefined

  if (trimmed.startsWith('/')) {
    return trimmed
  }

  if (typeof window === 'undefined') {
    return undefined
  }

  try {
    const url = new URL(trimmed, window.location.origin)
    if (url.origin !== window.location.origin) {
      return undefined
    }
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return undefined
  }
}

export const getStoredLoginPolicy = () => {
  if (typeof window === 'undefined') return DEFAULT_B2C_LOGIN_POLICY
  try {
    return localStorage.getItem(LOGIN_POLICY_KEY) || DEFAULT_B2C_LOGIN_POLICY
  } catch {
    return DEFAULT_B2C_LOGIN_POLICY
  }
}

export const getB2CAuthority = (policy?: string | null) => {
  const environmentDetails = getEnvironmentDetails()
  const resolvedPolicy = policy || DEFAULT_B2C_LOGIN_POLICY
  return `https://jyrneyb2c${environmentDetails}.b2clogin.com/jyrneyb2c${environmentDetails}.onmicrosoft.com/${resolvedPolicy}`
}

export const clearTransientAuthStorage = () => {
  if (typeof window === 'undefined') return

  try {
    window.localStorage.removeItem(LOGIN_POLICY_KEY)
    window.localStorage.removeItem(EMAIL_HINT_KEY)

    const keysToRemove = Object.keys(window.localStorage).filter((key) =>
      key.startsWith('token-scp-'),
    )
    keysToRemove.forEach((key) => window.localStorage.removeItem(key))
  } catch {
    // Storage can be unavailable or blocked; ignore cleanup failures.
  }
}

export const setPostLoginDestination = (destination?: string | null) => {
  const normalized = normalizeInternalDestination(destination)
  const storage = getSessionStorage()

  if (!storage) {
    inMemoryPostLoginDestination = normalized || null
    return
  }

  if (!normalized) {
    try {
      storage.removeItem(POST_LOGIN_DESTINATION_KEY)
    } catch {
      // Ignore storage write errors and fall back to memory state.
    }
    inMemoryPostLoginDestination = null
    return
  }

  try {
    storage.setItem(POST_LOGIN_DESTINATION_KEY, normalized)
  } catch {
    // Ignore storage write errors and fall back to memory state.
  }
  inMemoryPostLoginDestination = normalized
}

export const getPostLoginDestination = () => {
  const storage = getSessionStorage()
  if (!storage) {
    return normalizeInternalDestination(inMemoryPostLoginDestination)
  }

  try {
    return normalizeInternalDestination(
      storage.getItem(POST_LOGIN_DESTINATION_KEY) ||
        inMemoryPostLoginDestination,
    )
  } catch {
    return normalizeInternalDestination(inMemoryPostLoginDestination)
  }
}

export const clearPostLoginDestination = () => {
  setPostLoginDestination(undefined)
}
